import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import DataTable from '../shared/DataTable.jsx';
import ImageScreen from '../shared/ImageScreen.jsx';
import {
    ASSUMPTIONS,
    DATA_MODEL,
    INSIGHTS,
    RCA_GUIDE,
    SUMMARY_CARDS,
    ISSUE_KANBAN,
    OPTIMIZATION_TAB_IMAGES,
} from '../performanceAiData.js';

export class OptimizationModel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabValue: 0,
        };
    }

    handleTabChange = (event, newValue) => {
        this.setState({ tabValue: newValue });
    };

    renderTabPanel() {
        const { tabValue } = this.state;

        switch (tabValue) {
            case 0:
                return (
                    <DataTable
                        title="Assumptions"
                        headers={ASSUMPTIONS.headers}
                        rows={ASSUMPTIONS.rows}
                    />
                );
            case 1:
                return (
                    <DataTable
                        title="Data Model"
                        tag="1 workbook row + 4 dummy rows"
                        headers={DATA_MODEL.headers}
                        rows={DATA_MODEL.rows}
                    />
                );
            case 2:
                return (
                    <DataTable
                        title="Insights"
                        tag="Illustrative example — 5 rows, computed from Data Model + Assumptions"
                        headers={INSIGHTS.headers}
                        rows={INSIGHTS.rows}
                    />
                );
            case 3:
                return (
                    <div className="pa-table-card">
                        <div className="pa-table-card-head">
                            <h3>Issue Tracker — Kanban</h3>
                            <span className="pa-example-tag">Illustrative example — 4 dummy cards</span>
                        </div>
                        <div className="pa-kanban-row">
                            {ISSUE_KANBAN.map((column) => (
                                <div className="pa-kanban-col" key={column.title}>
                                    <h4>{column.title}</h4>
                                    {column.cards.map((card) => (
                                        <div
                                            className={`pa-kanban-card ${card.resolved ? 'resolved' : ''}`}
                                            key={card.title}
                                        >
                                            <span className="p0">{card.priority}</span>
                                            <div className="k-title">{card.title}</div>
                                            <div className="k-meta">{card.meta}</div>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                );
            case 4:
                return <ImageScreen {...OPTIMIZATION_TAB_IMAGES.performanceEmail} />;
            case 5:
                return (
                    <DataTable
                        title="RCA Guide"
                        headers={RCA_GUIDE.headers}
                        rows={RCA_GUIDE.rows}
                    />
                );
            case 6:
                return (
                    <div className="pa-table-card">
                        <div className="pa-table-card-head">
                            <h3>Impact Summary</h3>
                            <span className="pa-example-tag">Illustrative example — from the sample row</span>
                        </div>
                        <div className="pa-metric-cards">
                            {SUMMARY_CARDS.map(([label, value]) => (
                                <div className="pa-metric-card" key={label}>
                                    <div className="m-label">{label}</div>
                                    <div className="m-value">{value}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                );
            default:
                return null;
        }
    }

    render() {
        const { tabValue } = this.state;
        const tabs = [
            'Assumptions',
            'Data Model',
            'Insights',
            'Issue Resolution',
            'Performance Email',
            'RCA',
            'Impact',
        ];

        return (
            <>
                <Tabs
                    value={tabValue}
                    onChange={this.handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    className="pa-tabs"
                >
                    {tabs.map((label) => (
                        <Tab key={label} label={label} style={{ textTransform: 'none' }} />
                    ))}
                </Tabs>
                {this.renderTabPanel()}
            </>
        );
    }
}

export default OptimizationModel;
